import { Card, Group, Stack, Text, Title } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import paymentIcons from '../../constants/paymentIcons';

const PaymentAddButton = ({ addPayment }) => {
  const { hovered, ref } = useHover();

  const paymentIconsElements = Object.keys(paymentIcons).map((icon, index) => {
    const Icon = paymentIcons[icon]?.icon || paymentIcons.unknown.icon;
    return (
      <span key={index}>
        {' '}
        <Icon size={32} />
      </span>
    );
  });

  return (
    <Card
      ref={ref}
      onClick={() => addPayment()}
      padding="xl"
      style={{
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: `1px solid ${hovered ? 'var(--mantine-color-primary-5)' : 'var(--mantine-color-gray-3)'}`,
        backgroundColor: hovered ? 'var(--mantine-color-primary-0)' : 'white',
      }}
    >
      <Stack align="center" gap="sm">
        <Group gap="xs">
          <IconPlus size={20} color="var(--mantine-color-primary-5)" />
          <Title order={4} c="primary">Add payment method</Title>
        </Group>
        <Text c="dimmed">{paymentIconsElements}</Text>
      </Stack>
    </Card>
  );
};

export default PaymentAddButton;
